import { useEffect, useRef, useState } from 'react';
import { produce } from 'immer';
import { useNavigate, useParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { OneBtnFooter } from 'widgets/HsptlzForm/ui';

import { useGetContentDetailCodeList } from '../model/useGetContentDetailCodeList';

import { useModal } from './ModalProvider';

export const NextBtnContainer = () => {
  const { contentCode } = useParams();
  const contentDetailCodeList = useGetContentDetailCodeList();
  const [readAll, setReadAll] = useState(false);
  const readAllRef = useRef(false);
  const { guideModal, setGuideModal } = useModal();
  const setContentDetailData = useBoundStore((state) => state['hsptlzForm'].setContentDetailData);
  const sign = useBoundStore((state) => state['hsptlzForm'].sign);

  const navigate = useNavigate();

  const checkReadAll = () => {
    // 동의서 확인 여부 체크
    const pageHeight = document.body.scrollHeight - document.body.clientHeight;
    const isReadAll =
      pageHeight <=
      Math.ceil(window.scrollY) +
        Number(getComputedStyle(document.documentElement).getPropertyValue('--sab').split('px')[0]);

    if (isReadAll !== readAllRef.current) {
      readAllRef.current = isReadAll;
      setReadAll(isReadAll);
    }
  };

  const handleAnchor = () => {
    // anchor 처리
    // 데이터가 없을 경우 에러 데이터셋 Y
    const errorElement = document.querySelector('[data-error="Y"]');

    if (errorElement) {
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  };

  const handleSubmit = () => {
    const grandParent = document.querySelector('.mobile-temp-container');
    if (grandParent.dataset.submitted !== 'Y') grandParent.dataset.submitted = 'Y';

    const errorElements = grandParent.querySelectorAll('[data-error="Y"]');
    if (errorElements.length > 0) {
      setGuideModal(
        produce(guideModal, (draft) => {
          draft.open = true;
          draft.title = '아직 입력되지 않은 항목이 있어요';
          draft.subTitle = (
            <>
              동의서 제출을 위해 <br />
              필수 항목을 모두 입력해주세요.
            </>
          );
          draft.callback = () => {
            errorElements[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          };
        }),
      );
    } else {
      const data = contentDetailCodeList.reduce((acc, code) => {
        const element = document.querySelector(`[name="${code}"]`);
        const { status, value, type } = element.dataset;
        const resultValue = type === 'sign' ? sign[code] : value;

        return {
          ...acc,
          [code]: {
            status,
            value: resultValue,
            type,
          },
        };
      }, {});
      setContentDetailData(data);
      navigate(`/hsptlz/form/pdf-form/${contentCode}`);
    }
  };

  useEffect(() => {
    checkReadAll();
    document.addEventListener('scroll', checkReadAll);
    return () => {
      document.removeEventListener('scroll', checkReadAll);
    };
  }, []);

  return readAll ? <Submit handleSubmit={handleSubmit} /> : <Scroll handleAnchor={handleAnchor} />;
};

const Scroll = ({ handleAnchor }) => {
  return <OneBtnFooter text={'아래로 스크롤'} isValid={true} handleClick={handleAnchor} />;
};

const Submit = ({ handleSubmit }) => {
  return <OneBtnFooter text={'동의 후 제출'} isValid={true} handleClick={handleSubmit} />;
};
